module.exports = __webpack_public_path__ + "img/PlayStoreButton.f06b9089.png";